module.exports = __webpack_public_path__ + "assets/a19f43370a07d33f152a0b44590344c4.png";